const highlightStyles = {
  backgroundColor: '#FFEB3B',
  fontWeight: 'bold',
  padding: '1px 2px',
  borderRadius: '2px'
};

export default highlightStyles;
